/** ``verity_fpn_id_v2`` -> ``Verity Fpn Id V2``: the display name offered before one is typed. */
export function humanColumnName(name: string): string {
  return name
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
